import { DocumentType } from '../documents-page/table/documents-table.types';

export const getDocumentNameLocisedKey = (documentType: DocumentType) => {
  // t('document_check.table.document_name.employer_contract')

  const keyMap: Record<DocumentType, string> = {
    [DocumentType.EMPLOYER_CONTRACT]: 'document_check.table.document_name.employer_contract',
  };

  return keyMap[documentType];
};

export const getDocumentTypeLocisedKey = (documentType: DocumentType) => {
  // t('document_check.table.document_type.employer_contract')

  const keyMap: Record<DocumentType, string> = {
    [DocumentType.EMPLOYER_CONTRACT]: 'document_check.table.document_type.employer_contract',
  };

  return keyMap[documentType];
};
